<template>
<div class="page tableofcontents">
  <a name="contents"/>
  <p class="dustin-title has-text-centered">
    Table of Contents
  </p>
  <br>
  <div class="content is-large">
    <ol>
      <li v-if="renderedPages.CoverPage">
        &nbsp; <a href="#cover">Cover</a>
      </li>
      <li v-if="renderedPages.TableOfContents">
        &nbsp; <a href="#contents">Contents</a>
      </li>
      <li v-if="renderedPages.ApproachToData">
        &nbsp; <a href="#approach">Approach</a>
      </li>
      <li v-if="renderedPages.YourImpactPreferences">
        &nbsp; <a href="#impact-objectives">Impact Objectives</a>
      </li>
      <li v-if="renderedPages.PortfolioOverview">
        &nbsp; <a href="#portfolio-overview">Portfolio Overview</a>
      </li>
      <li v-if="renderedPages.Corporate">
        &nbsp; <a href="#corporate">Aggregate Impact</a>
      </li>
      <li v-if="renderedPages.Metaphors">
        &nbsp; <a href="#metaphors">YourImpact Metaphor Metrics</a>
      </li>
      <li v-if="renderedPages.ShareholderEngagement">
        &nbsp; <a href="#shareholder-engagement-methodology">Shareholder Engagement &#x2013; Methodology</a>
      </li>
      <li v-if="renderedPages.ShareholderEngagement">
        &nbsp; <a href="#shareholder-engagement">Shareholder Engagement &#x2013; Reporting</a>
      </li>
      <li v-if="renderedPages.Holdings">
        &nbsp; <a href="#holdings">Appendix A &#x2013; Portfolio Holdings</a>
      </li>
      <li v-if="renderedPages.BenchmarkHoldings">
        &nbsp; <a href="#benchmark-holdings">Appendix B &#x2013; Benchmark Holdings</a>
      </li>
    </ol>
  </div>
<!-- page-->

</div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    props: {
      renderedPages: Object
    }
  }
</script>

<style lang="scss" scoped>
  .tableofcontents {
    padding: 6rem;

    a {
      color: var(--black-95);
      border-bottom: 1px dashed #b5b5b5;
    }
  }
</style>
